
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employers-specialisms",
      function () {
        return require("private-next-pages/employers-specialisms/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employers-specialisms"])
      });
    }
  